// extracted by mini-css-extract-plugin
export default {"container":"styles_container__bCv4I","header":"styles_header__+KhWi","separator":"styles_separator__z0Rct","logo":"styles_logo__xuxMW"};